import { create } from 'apisauce';

import urlgetter from './getMainUrl';

let payAPI;

const api = create({
	baseURL: urlgetter.getMainApiUrl()
});

const mainAPI = create({
	baseURL: urlgetter.getMainApiUrl()
})

const func = {};
func.setApi = () => {
	if (window.ENV) {
		payAPI = create({
			baseURL: window.ENV?.paymentsApiUrl
		  })
	}
}
func.GetTimeslots = (date) => {
	return api.get(`/timeslots/?day=${date}`);
};

func.getMonthlySlots = (date) => {
	return api.get(`/timeslots/?startDay=${date.start}&endDay=${date.end}`)
};

func.getIdentityInfo = () => {
	return api.get('/processorInfo');
};

func.startSession = (identityToken) => {
	// console.log(identityToken);

	payAPI.setHeaders({
		Authorization:'Basic ' + Buffer.from(identityToken+':test').toString('base64'),
		Accept:'application/json'
    });
	
  	return payAPI.get('/SvcInfo/token');
};

func.getApplicationData = (sessionToken, profileId) => {
	
	payAPI.setHeaders({
		Authorization:'Basic ' + Buffer.from(sessionToken+':test').toString('base64'),
		Accept:'application/json'
    });
  	return payAPI.get(`/SvcInfo/appProfile/${profileId}`); 	
}

func.saveApplicationData = (sessionToken, applicationData) => {
	
	payAPI.setHeaders({
		Authorization:'Basic ' + Buffer.from(sessionToken+':test').toString('base64'),
		Accept:'application/json'
    });
  	return payAPI.put('/SvcInfo/appProfile', applicationData); 	
}
func.transnationalTransaction = (body) => {
	// console.log('in authorize and capture');
	// var token = authStore.getAuthToken();
	// if (token == '') {
	// 	token = localStorage.getItem("Auth-token");
	// }
	// console.log(token);
	mainAPI.setHeaders({
		"Content-Type": 'application/json'
	})
	return mainAPI.post(`transnational/proxy/transaction`, body);
}
func.cardConnetcAuthTransaction = (body) => {
	// console.log('in authorize and capture');
	// var token = authStore.getAuthToken();
	// if (token == '') {
	// 	token = localStorage.getItem("Auth-token");
	// }
	// console.log(token);
	mainAPI.setHeaders({
		"Content-Type": 'application/json'
	})
	return mainAPI.post(`cardConnectProxy/proxy/auth`, body);
}
func.cardConnetcCaptureTransaction = (body) => {
	// console.log('in authorize and capture');
	// var token = authStore.getAuthToken();
	// if (token == '') {
	// 	token = localStorage.getItem("Auth-token");
	// }
	// console.log(token);
	mainAPI.setHeaders({
		"Content-Type": 'application/json'
	})
	return mainAPI.post(`cardConnectProxy/proxy/capture`, body);
}
func.getServiceInformation = (sessionToken) => {	
	payAPI.setHeaders({
		Authorization:'Basic ' + Buffer.from(sessionToken+':test').toString('base64'),
		Accept:'application/json'
    });
  	return payAPI.get('/SvcInfo/serviceInformation'); 	
}

func.isMerchantProfileInitialized = (sessionToken, merchantProfileId, serviceId) => {
	payAPI.setHeaders({
		Authorization:'Basic ' + Buffer.from(sessionToken+':test').toString('base64'),
		Accept:'application/json'
    });
  	return payAPI.get(`/SvcInfo/merchProfile/${merchantProfileId}/OK?serviceId=${serviceId}`); 
}

func.authorizeAndCapture = (sessionToken, serviceId, body) => {
	// console.log('in authorize and capture');
	payAPI.setHeaders({
		Authorization:'Basic ' + Buffer.from(sessionToken+':test').toString('base64'),
		Accept:'application/json',
		"Content-Type" : 'application/json'
    });
	return payAPI.post(`/Txn/${serviceId}`, body); 
}

func.cancelAuthorizeAndCapture = (sessionToken, serviceId,transactionId, body) => {
	// console.log('in authorize and capture');
	payAPI.setHeaders({
		Authorization:'Basic ' + Buffer.from(sessionToken+':test').toString('base64'),
		Accept:'application/json',
		"Content-Type" : 'application/json'
    });
	return payAPI.put(`/Txn/${serviceId}/${transactionId}`, body); 
}

func.makeReservation = (reservationBody) => {
	// console.log("in make Reservation Activity");
	return api.post('/reservations',reservationBody);
}

func.cancelReservation = (reservationId, refundAmount) => {
	// console.log('in CancelReservation');
  return api.put('/reservations/' + reservationId + '/cancel', {refundAmount: refundAmount});
}

func.changeReservation = (reservationBody) => {
	// console.log('in changeReservation');
  return api.put('/reservations/' + reservationBody.id + '/changeReservation',reservationBody);
}

func.sendEmail = (body) => {
	return api.post(`/sendEmail`,body); 
}

func.UpdateGiftCard = (body) => {
	console.log("in Update Gift Card");
	return api.put('/giftcards',body);
}

func.verifyGiftCard = (cardBody) => {
	console.log("in make Reservation Activity");
	return api.post('/giftcards/verify',cardBody);
}


export default func;
